import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { labs } from "lobbie";
import { ELabsConfigType, ELabsVendorType } from "src/types/global_enums";

export interface ILabTestConfigDrawer {
    show: boolean;
    onCloseDrawer?: () => void;
    vendorType?: ELabsVendorType;
    configType?: ELabsConfigType;
    configPossibleChildrenPanels?: labs.ILabTestPanelConfig[];
    configPossibleChildrenComponents?: labs.ILabTestComponentConfig[];
    configId?: number;
}

export const initialStateLabsTestConfigDrawer: ILabTestConfigDrawer = {
    show: false,
    vendorType: undefined,
    configType: undefined,
    configId: undefined,
    configPossibleChildrenPanels: undefined,
    configPossibleChildrenComponents: undefined,
    onCloseDrawer: undefined,
};
const labsTestConfigDrawerSlice = createSlice({
    name: "labsTestConfigDrawer",
    initialState: initialStateLabsTestConfigDrawer,
    reducers: {
        showLabsTestConfigDrawer: (
            _state,
            action: PayloadAction<Omit<ILabTestConfigDrawer, "show">>,
        ) => {
            return {
                ...action.payload,
                show: true,
            };
        },
        hideLabsTestConfigDrawer: (_state) => {
            return initialStateLabsTestConfigDrawer;
        },
    },
});

export const { showLabsTestConfigDrawer, hideLabsTestConfigDrawer } =
    labsTestConfigDrawerSlice.actions;
export default labsTestConfigDrawerSlice.reducer;
